import React, { FC, useMemo } from 'react';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';
import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import { IClick } from '~/src/features/movix-new';
import HeaderTitleBlock from '~/src/features/movix-new/HeaderTitileBlock';

import * as ST from './styled';

export enum EMediaWidth {
    sDesktop = '(max-width: 1567px) and (min-width: 1280px)',
    laptop = '(max-width: 1279px) and (min-width: 769px)',
    tablet = '(max-width: 1023px)',
    mobile = '(max-width: 768px) and (min-width: 641px)',
    sMobile = '(max-width: 640px) and (min-width: 376px)',
    xSMobile = '(max-width: 375px)',
}

const headerBackgroundDesktop = '/static/images/movix-new/header-background-1920.jpg';
const headerBackgroundDesktopWebp = '/static/images/movix-new/header-background-1920.webp';

const headerBackgroundSDesktop = '/static/images/movix-new/header-background-1366.jpg';
const headerBackgroundSDesktopWebp = '/static/images/movix-new/header-background-1366.webp';

const headerBackgroundLaptop = '/static/images/movix-new/header-background-1024.jpg';
const headerBackgroundLaptopWebp = '/static/images/movix-new/header-background-1024.webp';

const headerBackgroundMobile = '/static/images/movix-new/header-background-768.jpg';
const headerBackgroundMobileWebp = '/static/images/movix-new/header-background-768.webp';

const headerBackgroundSMobile = '/static/images/movix-new/header-background-640.jpg';
const headerBackgroundSMobileWebp = '/static/images/movix-new/header-background-640.webp';

const headerBackgroundXSMobile = '/static/images/movix-new/header-background-320.jpg';
const headerBackgroundXSMobileWebp = '/static/images/movix-new/header-background-320.webp';

interface IProps {
    handleClick: (data: IClick) => void,
}

const Header: FC<IProps> = ({ handleClick }) => {
    const isDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);
    const isTablet = useMatchMedia(EMediaWidth.tablet);
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const isSMobile = useMatchMedia(EMediaWidth.sMobile);
    const isXSMobile = useMatchMedia(EMediaWidth.xSMobile);

    const backgroundWebp = useMemo((): string => {
        switch (true) {
            case isDesktop:
                return headerBackgroundSDesktopWebp;
            case isLaptop:
                return headerBackgroundLaptopWebp;
            case isMobile:
                return headerBackgroundMobileWebp;
            case isSMobile:
                return headerBackgroundSMobileWebp;
            case isXSMobile:
                return headerBackgroundXSMobileWebp;
            default:
                return headerBackgroundDesktopWebp;
        }
    }, [isDesktop, isLaptop, isMobile, isSMobile, isXSMobile]);

    const background = useMemo((): string => {
        switch (true) {
            case isDesktop:
                return headerBackgroundSDesktop;
            case isLaptop:
                return headerBackgroundLaptop;
            case isMobile:
                return headerBackgroundMobile;
            case isSMobile:
                return headerBackgroundSMobile;
            case isXSMobile:
                return headerBackgroundXSMobile;
            default:
                return headerBackgroundDesktop;
        }
    }, [isDesktop, isLaptop, isMobile, isSMobile, isXSMobile]);

    const backgroundImage = useWebp() ? backgroundWebp : background;

    return (<ST.Wrapper>
        <ST.HeaderBlock backgroundImg={backgroundImage}>
            {!isTablet && <HeaderTitleBlock handleClick={handleClick}/>}
        </ST.HeaderBlock>
        {isTablet &&
            <ST.ContainerMobileTitle>
                <HeaderTitleBlock handleClick={handleClick}/>
            </ST.ContainerMobileTitle>
        }
    </ST.Wrapper>);
};

export default Header;
